import { Icon } from 'antd';
import moment from 'moment';
import * as React from 'react';
import { useEffect, useState } from 'react';
import SEDocumentBar from './SEDocumentBar';
import { isValidArray } from 'src/Library/Helper';
import useDocument from 'src/hooks/form/useDocument';
import useFieldGroup from 'src/hooks/form/useFieldGroup';
import SEFieldGroup from '../../../SECommon/SEFieldGroup';
import SEFieldInput from '../../../SECommon/SEFieldInput';
import { documentTemplateType } from "./SEUploadDocumentsTaskDetails";
import { getFieldForDocumentTemplates } from 'src/api/shipmentExecution';
import { getGrpFieldsProps, parseFormValues } from '../../../SECommon/SEFieldGroupUtils';
import { useReduxState } from 'src/hooks/useRedux';
import injectSheet from 'react-jss';
import { set } from 'lodash';
import Asterisk from 'src/components/common/Asterisk';

const styles = theme => ({
  spaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  blackHeader: {
    color: theme.colors.text,
    fontSize: theme.fontSize.body,
    fontWeight: theme.fontWeight.semibold,
  },
  line: {
    display: 'flex',
    height: 1,
    backgroundColor: '#EDEDED',
    margin: `${theme.spacing.sm}px 0px`,
  },
  madatory: {
    color: 'red',
    fontSize: theme.fontSize.small,
    verticalAlign: 'text-top'
  }
});

const DocumentTemplate = (props) => {
  const {
    form,
    classes,
    sourceObjectId,
    templateOptions,
    taskUpdateActions,
    selectedTemplateKey,
    setIsUpdateDisabled,
    handleDeleteTemplate,
    setDocumentDetails,
    submitClicked,
    enableMultipleDuplicateValues,
  } = props;

  const selectedTemplate : documentTemplateType = templateOptions.find(template => template.key === selectedTemplateKey);

  const dropdownMasterValues = useReduxState([ 'shipmentExecutionReducer', 'dropdownMaster' ]).value;

  const document = useDocument({
    form,
    disabled: false,
    visible: true,
    label: '',
    multi: true,
    isMulti: true,
    accept: '.pdf, .jpg, .jpeg, .png, .xlsx, .xls, .csv, .doc, .docx,.msg, .eml',
  });
  const [documentFieldTemplateIds , setDocumentFieldTemplateIds] = useState<string[] | undefined>([]); 
  const [documentField, setDocumentField] = useState<any[]>([{
    name: '',
    url: ''
  }]);
  const [listOfs3Files, setListOfs3Files] = useState<any[]>([]);
  useEffect(() => {
    setIsUpdateDisabled(document.isUploading);
  }, [document.isUploading]);

  useEffect(() => {
    if (submitClicked){
      setDocumentDetails(prevState => {
        return [...prevState, createApiCallObject()]
      });
      // setDocumentField([]);
    }
  }, [submitClicked])

  const documentTemplate = templateOptions?.find(template => template.key === selectedTemplateKey);
  const renderDeleteTemplate = (template: documentTemplateType) => {
    return (
      <Icon
        style={{
          marginLeft: 8,
        }}
        type="delete"
        onClick={() => {
          handleDeleteTemplate(template.key);
        }}
      />
    );
  }

  const renderLine = () => {
    return (
      <div className={classes.line} />
    );
  }

  const renderDocumentHeader = (documentTemplate: documentTemplateType | undefined) => {
    if (!documentTemplate) {
      return;
    }
    return (
      <div>
        <div className={classes.spaceBetween}>
          <div className={classes.blackHeader}>
            {documentTemplate?.label}
            <span className={classes.madatory}>{documentTemplate?.isMandatory ? <Asterisk /> : null}</span>
          </div>
          <div>
            {document.decorator(<SEFieldInput field={document} />)}
            {renderDeleteTemplate(documentTemplate)}
          </div>
        </div>
        {renderLine()}
      </div>
    );
  }

  const handleDeleteDoc = (fileToRemove) => {
    setListOfs3Files((prevFiles) =>
    prevFiles.filter((f) => f.s3Link !== fileToRemove.s3Link)
  );
};

const createApiCallObject = () => {
  // Collect field info if needed
  let fields;
  if (form.getFieldsValue().documentField) {
    fields = form.getFieldsValue().documentField
      .map((field, idx) => ({
        fieldTemplateId: idx.toString(),
        values: parseFormValues(field, enableMultipleDuplicateValues),
      }))
      .filter(
        (el) => Array.isArray(el.values)
          && documentFieldTemplateIds?.includes(el.fieldTemplateId)
      );
  }

  // Map each doc to get { name, url } from doc.name / doc.s3Link
  const documentDetails = documentField.map(doc => ({
    name: doc.name || '',
    url: doc.s3Link || '',
    ...(fields && { fields }),
  }));

  const documentTemplateId = selectedTemplate.id;
  const documentTemplateName = selectedTemplate.label;

  // Return one object in an array, with documentDetails as an array
  return (
    {
      documentDetails,
      documentTemplateId,
      documentTemplateName,
    });
};

useEffect(() => {
  const file = document.s3File;
  if (!file) return;

  if (
    typeof file.ext === "string" && file.ext.trim() !== "" &&
    typeof file.name === "string" && file.name.trim() !== "" &&
    typeof file.s3Link === "string" && file.s3Link.trim() !== ""
  ) {
    setListOfs3Files((prevFiles) => [...prevFiles, file]);
  }
}, [document.s3File]);
  const renderDocuments = (documentTemplate: documentTemplateType | undefined) => {
    // Show the list of files we've accumulated
    if (listOfs3Files.length > 0) {
      return listOfs3Files.map((file, index) => (
        <SEDocumentBar
          key={index}
          index={index}
          showTitle={false}
          onRemove={() => handleDeleteDoc(file)}  // adjust as needed
          isDeleteDisabled={document.isUploading} // if you still rely on document.isUploading
          containerBoxStyle={{ margin: '10px 12px' }}
          showColumnHeader={index === 0} 
          document={{
            updatedAt: moment(),
            documentType: documentTemplate?.label,
            name: file.name,
            url: file.s3Link,
          }}
        />
      ));
    }
  
    // No files? Return null or a placeholder.
    return null;
  };

  const [nodes, setNodes] = React.useState<any[]>([]);
  const fieldGroup = useFieldGroup({ defaultNodes: [] });

  useEffect(() => {
    if (!document.value?.length || document.value?.length > 1) {
      return;
    }
    // document.disable();
    const url = document.value?.[0]?.url;
    if (url?.length) {
      handleGetFieldForTemplate(selectedTemplate.id);
    }
  }, [document.value]);
 useEffect(() => {
  setDocumentField(listOfs3Files)
 }, [listOfs3Files])
  //setDocumentField
  useEffect(() => {
    fieldGroup.setNodes([...nodes]);
  }, [nodes]);

  const handleGetFieldForTemplate = async (documentTemplateId: string | undefined) => {
    if (!documentTemplateId) {
      return;
    }

    const response = await getFieldForDocumentTemplates({
      id: sourceObjectId,
      documentTemplateId,
    });

    setDocumentFieldTemplateIds((response.data?.fields)?.map((field) => field.fieldTemplateId));
    
    if (response.isSuccess) {
      const { data } = response;
      if (data) {
        const fields = getGrpFieldsProps({
          form,
          fields: data.fields,
          keyCB: (key) => `documentField[${key}]`,
          defaultDisabled: false,
        }) || [];
        setNodes(fields);
      } else {
        setNodes([]);
      }
    }
  }

  const renderRelatedFields = (documentTemplate: documentTemplateType | undefined) => {
    if (!documentTemplate) {
      return;
    }

    if (!isValidArray(nodes)) {
      return (
        <div style={{ marginBottom: 80 }}>

        </div>
      );
    }

    return (
      <SEFieldGroup
        fieldGroup={fieldGroup}
        dropdownMasterValues={dropdownMasterValues}
      />
    );
  }

  return (
    <>
      {renderDocumentHeader(documentTemplate)}
      {renderDocuments(documentTemplate)}
      {renderRelatedFields(documentTemplate)}
    </>
  );
}

export default injectSheet(styles)(DocumentTemplate);